import con from '../../static/contact.svg'

  export const contact = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Rohaan Joshi',
    headline:
      'AnyTime you can Contact Me!!!',
    description:
      "I will respond to all your queries, Emails or Instagram Dm's within Business Days. You will get a reply from my end between 10:00AM and 5:00PM IST. I will definitely reply to your mails and messages within 2-3 days.",
    buttonLabel: ' rohaanjosh@gmail.com',
    imgStart: 'start',
    img: con,
    alt: 'Vault',
    start: 'true'
  }